// Mock data seed for Eagle Academy clone
const firstNames = ["Emma","Liam","Olivia","Noah","Ava","Ethan","Sophia","Mason","Isabella","Lucas","Mia","Logan","Charlotte","Aiden","Amelia","Jayden","Harper","Elijah","Evelyn","Carter","Abigail","James","Emily","Sebastian","Ella","Michael","Elizabeth","Daniel","Camila","Henry","Luna","Jackson","Sofia","Benjamin","Avery","Alexander","Mila","William","Aria","Owen","Scarlett","Wyatt","Penelope","Julian","Layla","Levi","Chloe","David","Victoria","Gabriel","Madison","Anthony","Eleanor","Isaac","Grace","Grayson","Nora","Matthew","Riley","Samuel","Zoey","Joseph","Hannah","John","Hazel","Andrew","Lily","Dylan","Ellie","Lincoln","Violet"];
const lastNames = ["Smith","Johnson","Williams","Brown","Jones","Garcia","Miller","Davis","Rodriguez","Martinez","Hernandez","Lopez","Gonzalez","Wilson","Anderson","Thomas","Taylor","Moore","Jackson","Martin","Lee","Perez","Thompson","White","Harris","Sanchez","Clark","Ramirez","Lewis","Robinson","Walker","Young","Allen","King","Wright","Scott","Torres","Nguyen","Hill","Flores","Green","Adams","Nelson","Baker","Hall","Rivera","Campbell","Mitchell","Carter","Roberts"];
const courses = [
  { name: "Math", short: "MATH", teacher: "Ms. Anderson", email: "sanderson@iltexas.org" },
  { name: "ELA", short: "ELA", teacher: "Mr. Thompson", email: "kthompson@iltexas.org" },
  { name: "Science", short: "SCI", teacher: "Mrs. Rodriguez", email: "mrodriguez@iltexas.org" },
  { name: "Social Studies", short: "SS", teacher: "Mr. Patel", email: "rpatel@iltexas.org" },
  { name: "Spanish", short: "SPAN", teacher: "Sra. Garcia", email: "lgarcia@iltexas.org" },
  { name: "Chinese", short: "CHIN", teacher: "Ms. Chen", email: "wchen@iltexas.org" },
  { name: "PE", short: "PE", teacher: "Coach Wilson", email: "twilson@iltexas.org" },
];

const rand = (arr) => arr[Math.floor(Math.random() * arr.length)];
const randInt = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;
const uid = () => Math.random().toString(36).slice(2, 12);

// Seed students
export const seedStudents = () => {
  const students = [];
  for (let i = 0; i < 728; i++) {
    const fn = rand(firstNames);
    const ln = rand(lastNames);
    const grade = String(randInt(4, 8));
    const otherId = String(100000 + i);
    students.push({
      id: uid(),
      student_id: otherId,
      first_name: fn,
      last_name: ln,
      grade_level: grade,
      email: `${fn.toLowerCase()}.${ln.toLowerCase()}${i}@iltexasstudent.org`,
      barcode: `BC${otherId}`,
      driveline_tag: String(randInt(100, 999)),
      created_date: new Date(Date.now() - randInt(1, 300) * 86400000).toISOString(),
    });
  }
  return students;
};

export const seedRosterEntries = (students) => {
  const entries = [];
  const now = new Date();
  const today = now.toISOString().split("T")[0];
  const statuses = ["pending", "present", "absent", "refusal"];
  const eaStatuses = ["active", "excused", "completed"];

  // 30 active EA students
  for (let i = 0; i < 30; i++) {
    const s = students[randInt(0, students.length - 1)];
    const c = rand(courses);
    entries.push({
      id: uid(),
      other_id: s.student_id,
      student_id: s.student_id,
      student_first_name: s.first_name,
      student_last_name: s.last_name,
      grade_level: s.grade_level,
      course: c.name,
      course_short_description: c.short,
      section: `${c.short}-${randInt(1, 5)}`,
      teacher: c.teacher,
      teacher_email: c.email,
      assignment: `${c.name} Failed Test ${randInt(1, 5)}`,
      assignment_grade: String(randInt(30, 65)),
      athletic_grade: String(randInt(40, 68)),
      campus: "WPK8",
      date: today,
      time: `${randInt(7, 8)}:${randInt(10, 59)}:00`,
      report_date: today,
      status: rand(eaStatuses),
      attendance_status: rand(statuses),
      assignment_type: Math.random() > 0.8 ? "manual" : "report",
      student_email: s.email,
      f1g1_parent_email: `parent.${s.last_name.toLowerCase()}@gmail.com`,
      f1g1_parent_phone: `972-555-${String(randInt(1000, 9999))}`,
      created_date: new Date(now - randInt(0, 7) * 86400000).toISOString(),
    });
  }

  // 13 ASD entries
  for (let i = 0; i < 13; i++) {
    const s = students[randInt(0, students.length - 1)];
    const c = rand(courses);
    entries.push({
      id: uid(),
      other_id: s.student_id,
      student_id: s.student_id,
      student_first_name: s.first_name,
      student_last_name: s.last_name,
      grade_level: s.grade_level,
      course: c.name,
      course_short_description: c.short,
      teacher: c.teacher,
      teacher_email: c.email,
      assignment: "Refused EA",
      campus: "WPK8",
      date: today,
      status: "asd",
      attendance_status: "pending",
      created_date: new Date(now - randInt(0, 7) * 86400000).toISOString(),
    });
  }
  return entries;
};

export const seedGradeReports = () => {
  const reports = [];
  const now = Date.now();
  for (let i = 0; i < 5; i++) {
    const d = new Date(now - i * 3 * 86400000);
    reports.push({
      id: uid(),
      report_date: d.toISOString().split("T")[0],
      entries_added: randInt(20, 80),
      duplicates_removed: randInt(0, 10),
      skipped: randInt(0, 5),
      status: "processed",
      report_name: `Report: ${d.toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}`,
      created_date: d.toISOString(),
    });
  }
  return reports;
};

export const seedTeachers = () => {
  return courses.map((c, idx) => ({
    id: uid(),
    full_name: c.teacher,
    email: c.email,
    user_type: "teacher",
    role: "user",
    grade_levels: ["4", "5", "6", "7", "8"].slice(randInt(0, 2), randInt(3, 5)),
    subjects: [c.name],
    created_date: new Date(Date.now() - randInt(30, 365) * 86400000).toISOString(),
  }));
};

export const seedUsers = (teachers) => {
  const adminUser = {
    id: "admin-1",
    full_name: "Chanique Steele",
    email: "csteele@iltexas.org",
    role: "admin",
    user_type: null,
    created_date: new Date("2025-08-01").toISOString(),
  };
  const eaStaff = [
    { id: uid(), full_name: "Maria Lopez", email: "mlopez@iltexas.org", role: "user", user_type: "ea_staff" },
    { id: uid(), full_name: "James Wright", email: "jwright@iltexas.org", role: "user", user_type: "ea_staff" },
  ];
  const driveline = [
    { id: uid(), full_name: "Sarah Bennett", email: "sbennett@iltexas.org", role: "user", user_type: "driveline" },
  ];
  const aps = [
    { id: uid(), full_name: "Dr. Marcus Reed", email: "mreed@iltexas.org", role: "user", user_type: "assistant_principal", ap_grade_cohort: "4-5" },
    { id: uid(), full_name: "Dr. Angela Foster", email: "afoster@iltexas.org", role: "user", user_type: "assistant_principal", ap_grade_cohort: "6-8" },
  ];
  return [adminUser, ...teachers, ...eaStaff, ...driveline, ...aps];
};

export const seedContent = () => [
  {
    id: uid(),
    content_key: "student_announcements",
    title: "Student Announcements",
    body: "Welcome to Eagle Academy! Please review the EA/ASD guidelines and be on time for your assignments.",
    last_updated: new Date().toISOString(),
  },
  {
    id: uid(),
    content_key: "teacher_announcements",
    title: "Teacher Announcements",
    body: "Reminder: Submit weekly grade reports by Friday 3pm.",
    last_updated: new Date().toISOString(),
  },
  {
    id: uid(),
    content_key: "student_guidelines",
    title: "EA/ASD Guidelines",
    body: "Eagle Academy (EA) is our after-school academic support program. Students assigned to EA are expected to attend the full session and complete their missing or failed work.",
    last_updated: new Date().toISOString(),
  },
];

export const seedSettings = () => [
  {
    id: uid(),
    setting_key: "domain_mapping",
    student_email_domain: "@iltexasstudent.org",
    teacher_email_domain: "@iltexas.org",
    domain_auto_assignment_enabled: true,
  },
  {
    id: uid(),
    setting_key: "ea_settings",
    ea_start_time: "07:00",
    ea_end_time: "07:45",
    passing_grade_threshold: 70,
  },
];

export const seedConsequenceLevels = () => [
  { id: uid(), level: 1, misses: 1, name: "Warning", description: "Verbal warning issued to student and parent notification.", color: "yellow" },
  { id: uid(), level: 2, misses: 2, name: "Parent Meeting", description: "Mandatory parent meeting with AP.", color: "orange" },
  { id: uid(), level: 3, misses: 3, name: "Saturday Detention", description: "Student assigned to Saturday detention.", color: "red" },
  { id: uid(), level: 4, misses: 5, name: "ISS (In-School Suspension)", description: "One day in-school suspension.", color: "red" },
];

export const seedSupportTickets = () => [
  { id: uid(), subject: "Cannot view my roster", body: "The roster page is showing an error when I open it.", status: "new", submitter_email: "kthompson@iltexas.org", submitter_name: "Mr. Thompson", created_date: new Date(Date.now() - 2 * 86400000).toISOString() },
  { id: uid(), subject: "Excusal request stuck", body: "My excusal request from last week is still pending.", status: "in_progress", submitter_email: "mrodriguez@iltexas.org", submitter_name: "Mrs. Rodriguez", created_date: new Date(Date.now() - 5 * 86400000).toISOString() },
];

export const seedExcusals = (roster) => {
  const active = roster.filter((r) => r.status === "active").slice(0, 4);
  return active.map((r) => ({
    id: uid(),
    roster_entry_id: r.id,
    student_first_name: r.student_first_name,
    student_last_name: r.student_last_name,
    other_id: r.other_id,
    teacher_email: r.teacher_email,
    teacher_name: r.teacher,
    reason: rand(["Medical appointment", "Family emergency", "Approved sports event", "Field trip"]),
    status: rand(["pending", "approved", "denied"]),
    submitted_by: r.teacher_email,
    created_date: new Date(Date.now() - randInt(0, 5) * 86400000).toISOString(),
  }));
};
